import store from '../store/store';


const getLang = () => {
	const app = store.getState()
		.dataStates.data
		.activity_data.data
		.data_js.app;
	const langs_apps_js = store.getState()
		.dataStates.data
		.login.data
		.data_js
		.langs_apps_js;
	return langs_apps_js[app];
}

const randomFeedback = {


	positive: {
		"portuguese": ["Fantástico!", "Bem feito.", "Beleza!", "Ótimo!"],
		"spanish": ["¡Fantástico!", "Bien hecho.", "¡Bravo!", "¡Muy bien!"],
	},

	negative: {
		"portuguese": ["Tenta outra seleção!", "Não!", "Não é isso."],
		"spanish": ["Intenta otra vez.", "¡No!", "No es eso."],
	},

	get getPositive() {
		const lang = getLang();
		const index = Math.floor(Math.random() * this.positive[lang].length);
		return this.positive[lang][index];
	},

	get getNegative() {
		const lang = getLang();
		const index = Math.floor(Math.random() * this.negative[lang].length);
		return this.negative[lang][index];
	}
};

export default randomFeedback;
